<div class="container-fluid">
  <h5 class="mb-3">Payroll Summary</h5>
  <div class="card p-3">
    <div class="row">
      <p class="col-lg-3 text-lg-end">Entity:</p>
      <p class="col-lg-3 fw-bold">{{ businessEntity$ | async }}</p>
      <p class="col-lg-1 text-lg-end">Processed On:</p>
      <p class="col-lg-5 fw-bold">
        {{ (runningPayroll$ | async)?.processedOn | date: 'MMM dd, yyyy' }}
      </p>
    </div>
    <div class="row">
      <p class="col-lg-3 text-lg-end">Payroll Period:</p>
      <p class="col-lg-3 fw-bold">
        {{ (runningPayroll$ | async)?.payPeriodStart | date: 'dd MMM' }} to
        {{ (runningPayroll$ | async)?.payPeriodEnd | date: 'dd MMM' }}
      </p>
      <p class="col-lg-1 text-lg-end">Processed By:</p>
      <p class="col-lg-5 fw-bold">
        {{ (runningPayroll$ | async)?.payoutProcessedByUser?.firstName | capitalize }}
        {{ (runningPayroll$ | async)?.payoutProcessedByUser?.lastName | capitalize }}
        <span *ngIf="(runningPayroll$ | async)?.payoutProcessedByUser?.empId">
          ({{ (runningPayroll$ | async)?.payoutProcessedByUser?.empId }})
        </span>
      </p>
    </div>
    <div class="row">
      <p class="col-lg-3 text-lg-end">Number of employees Paid:</p>
      <p class="col-lg-3 fw-bold">{{ (runningPayroll$ | async)?.contractorCount }}</p>
      <p class="col-lg-1 text-lg-end">Paid On:</p>
      <p class="col-lg-5 fw-bold">
        {{ (runningPayroll$ | async)?.dateOfPayment | date: 'MMM dd, yyyy' }}
      </p>
    </div>
    <div class="row">
      <p class="col-lg-3 text-lg-end">Net Salary:</p>
      <div class="col-lg-3">
        <span class="fw-bold"
          >{{
            (runningPayroll$ | async)?.netAmount | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
          }}
        </span>
        <!--<a href="#" class="col-lg-9 ms-5">Compare with previous payroll (Apr 2025)</a>-->
      </div>
      <p class="col-lg-1 text-lg-end">Paid By:</p>
      <p class="col-lg-5 fw-bold">
        {{ (runningPayroll$ | async)?.payoutPaidByUser?.firstName | capitalize }}
        {{ (runningPayroll$ | async)?.payoutPaidByUser?.lastName | capitalize }}
        <span *ngIf="(runningPayroll$ | async)?.payoutPaidByUser?.empId">
          ({{ (runningPayroll$ | async)?.payoutPaidByUser?.empId }})
        </span>
      </p>
    </div>
    <div class="row">
      <p class="col-lg-3 text-lg-end">Gross Salary:</p>
      <p class="col-lg-2 fw-bold">
        {{
          (runningPayroll$ | async)?.totalAmount | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
        }}
      </p>
      <p class="col-lg-2 text-lg-end">TDS:</p>
      <p class="col-lg-5 fw-bold">
        {{ (runningPayroll$ | async)?.totalTds | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}
      </p>
    </div>
  </div>

  <!-- Employee Payroll Table -->
  <div class="card">
    <!--<div class="card-header d-flex flex-row-reverse">
      <div class="form-sort">
        <input type="search" class="form-control" placeholder="Search" />
      </div>
    </div>-->
    <div class="card-body p-0">
      <table class="table datatable text-center">
        <thead class="thead-light">
          <tr>
            <th>Full Name</th>
            <th>Gross Salary</th>
            <th>Net Salary</th>
            <th>TDS</th>
            <th>Key Settings</th>
            <th>Invoice Preview</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let payroll of currentIncomingPayrolls; let i = index">
            <td>
              <div class="d-flex align-items-center ps-5">
                <a
                  [routerLink]="[eps.hrm.employeePath, payroll.employee.id]"
                  class="avatar avatar-md"
                >
                  <!-- <img
                        [src]="employee.picture ? businessImages[employee.picture] : defaultImg"
                        class="img-fluid rounded-circle"
                        alt="img"
                      /> -->
                  <ng-container *ngIf="payroll.employee.picture; else initials">
                    <img
                      [src]="imageBaseUrl + payroll.employee.picture"
                      class="img-fluid rounded-circle"
                      alt="img"
                      style="width: 100%; height: 100%; object-fit: cover"
                    />
                  </ng-container>

                  <ng-template #initials>
                    <span
                      class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                      style="width: 30px; height: 30px"
                      >{{
                        getInitials(payroll.employee.firstName, payroll.employee.lastName)
                      }}</span
                    >
                  </ng-template>
                </a>
                <div class="ms-2 text-start d-block">
                  <p class="text-dark mb-0">
                    <a [routerLink]="[eps.hrm.employeePath, payroll.employee.id]"
                      >{{ payroll.employee.firstName | capitalize }}
                      {{ payroll.employee.lastName | capitalize }}</a
                    >
                    <span class="fs-12"> ({{ currentIncomingPayrolls[i]?.employee?.empId }})</span>
                  </p>
                  <span class="fs-12">{{
                    payroll.employee.designation?.designationName | capitalize
                  }}</span>
                </div>
              </div>
            </td>
            <!--<td></td>-->
            <td>{{ payroll.grossPayout | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN' }}</td>
            <td>{{ payroll.netPayout | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}</td>
            <td>{{ payroll.tds | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}</td>
            <td>
              <button (click)="openModal(KeySettingsComponent, i)" class="btn bg-transparent">
                <i class="ti ti-eye"></i>
              </button>
            </td>
            <td>
              <button (click)="openModal(InvoiceComponent, i)" class="btn bg-transparent">
                <i class="ti ti-eye"></i>
              </button>
            </td>
            <!--<td><a href="#">View</a></td>-->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- pagination -->
  <!--<ng-container>
    <div class="d-flex align-items-center justify-content-between ms-2">
      <div>
        Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
        {{ totalCount }} entries
      </div>
      <div class="has-text-centered mt-3">
        <app-pagination
          [currentPage]="currentPage"
          [pageSize]="pageLimit"
          [totalRows]="totalCount"
          (pageChange)="onPageChange($event)"
        ></app-pagination>
      </div>
    </div>
  </ng-container>-->
  <!-- pagination end -->
  <!-- Confirm Payroll Button Bottom -->
  <div
    *ngIf="
      (runningPayroll$ | async)?.status !== PayrollStatus.PROCESSED &&
      (runningPayroll$ | async)?.status !== PayrollStatus.PAID
    "
    class="text-center"
  >
    <button class="btn btn-light" (click)="changeScreen(false)">Edit Earnings</button>
    <button class="btn btn-primary ms-2" (click)="confirmPayroll()" [disabled]="!canConfirm">
      Confirm Payroll
    </button>
  </div>
</div>
